import { Component, Input, OnChanges } from '@angular/core';
import {
	THEME_COLOR_BLUE,
	THEME_COLOR_GREEN,
	THEME_COLOR_MAIN,
	THEME_COLOR_PINK,
	THEME_COLOR_VIOLET
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';

@Component({
	selector: 'app-travel-distance-dispersion',
	templateUrl: './travel-distance-dispersion.component.html',
	styleUrls: ['./travel-distance-dispersion.component.scss']
})
export class TravelDistanceDispersionComponent implements OnChanges {
	allstatistiques: any[] = [];
	@Input() categorie;
	@Input() statistiquesDistance: any;
	colorArray = {
		'1': THEME_COLOR_BLUE,
		'2': THEME_COLOR_GREEN,
		'3': THEME_COLOR_PINK,
		'4': THEME_COLOR_VIOLET
	};

	options2;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	constructor(private facade: FacadeService) {
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
	}

	ngOnChanges() {
		this.allstatistiques = [];

		this.statistiquesDistance.forEach((statsDist) => {
			this.allstatistiques.push([
				statsDist?.distanceQ1 / 1000,
				statsDist?.distanceQ3 / 1000,
				statsDist?.distanceMin / 1000,
				statsDist?.distanceMax / 1000,
				statsDist?.distanceMoyenne / 1000
			]);
		});

		if (this.isSESSAD) {
			this.options2 = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					formatter(params) {
						const tooltip =
							'Q1:' +
							params[0].data.value[1] +
							' Kms' +
							'<br>Q3: ' +
							params[0].data.value[2] +
							' Kms' +
							'<br>distanceMin:' +
							params[0].data.value[3] +
							' Kms' +
							'<br> distanceMax:' +
							params[0].data.value[4] +
							' Kms' +
							'';

						return tooltip;
					}
				},
				legend: {
					data: ['LPC', 'LSF', 'PDN', 'Oral'],
					align: 'left'
				},
				xAxis: {
					data: [
						{
							value: 'Distance Parcourue LPC',
							textStyle: { fontSize: 20, color: THEME_COLOR_MAIN }
						},
						{
							value: 'Distance Parcourue LSF',
							textStyle: { fontSize: 20, color: THEME_COLOR_MAIN }
						},
						{
							value: 'Distance Parcourue PDN',
							textStyle: { fontSize: 20, color: THEME_COLOR_MAIN }
						},
						{
							value: 'Distance Parcourue Oral',
							textStyle: { fontSize: 20, color: THEME_COLOR_MAIN }
						}
					],
					axisTick: {
						alignWithLabel: true
					},
					nameTextStyle: { color: THEME_COLOR_MAIN },
					axisLabel: {
						color: THEME_COLOR_MAIN
					}
				},
				yAxis: {
					name: 'Distance en Km',
					nameLocation: 'middle',
					nameGap: 50,
					nameTextStyle: { color: THEME_COLOR_MAIN },
					axisLabel: {
						color: THEME_COLOR_MAIN
					}
				},
				series: [
					{
						type: 'k',
						data: [
							{
								value: this.allstatistiques[0],
								itemStyle: {
									color: THEME_COLOR_BLUE,
									borderColor: THEME_COLOR_MAIN
								}
							},
							{
								value: this.allstatistiques[1],
								itemStyle: {
									color: THEME_COLOR_GREEN,
									borderColor: THEME_COLOR_MAIN
								}
							},
							{
								value: this.allstatistiques[2],
								itemStyle: {
									color: THEME_COLOR_PINK,
									borderColor: THEME_COLOR_MAIN
								}
							},
							{
								value: this.allstatistiques[3],
								itemStyle: {
									color: THEME_COLOR_VIOLET,
									borderColor: THEME_COLOR_MAIN
								}
							}
						]
					}
				]
			};
		} else if (this.isSAAD) {
			this.options2 = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					formatter(params) {
						const tooltip =
							'Q1:' +
							params[0].data.value[1] +
							' Kms' +
							'<br>Q3: ' +
							params[0].data.value[2] +
							' Kms' +
							'<br>distanceMin:' +
							params[0].data.value[3] +
							' Kms' +
							'<br> distanceMax:' +
							params[0].data.value[4] +
							' Kms' +
							'';

						return tooltip;
					}
				},
				legend: {
					data: ['Aide à domicile'],
					align: 'left'
				},
				xAxis: {
					data: [
						{
							value: 'Distance Parcourue',
							textStyle: { fontSize: 20, color: THEME_COLOR_MAIN }
						}
					],
					axisTick: {
						alignWithLabel: true
					},
					nameTextStyle: { color: THEME_COLOR_MAIN },
					axisLabel: {
						color: THEME_COLOR_MAIN
					}
				},
				yAxis: {
					name: 'Distance en Km',
					nameLocation: 'middle',
					nameGap: 50,
					nameTextStyle: { color: THEME_COLOR_MAIN },
					axisLabel: {
						color: THEME_COLOR_MAIN
					}
				},
				series: [
					{
						type: 'k',
						data: [
							{
								value: this.allstatistiques[0],
								itemStyle: {
									color: THEME_COLOR_BLUE,
									borderColor: THEME_COLOR_MAIN
								}
							}
						]
					}
				]
			};
		}
	}
}
